export default "__VITE_ASSET__32f7e049__"